import sdl from '@jds/react-generated-sdl/JDSBreadcrumbs';
import type { JDSBreadcrumbsProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, BreadcrumbProps } from '../logic';

const Component = (props: BreadcrumbProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSBreadcrumbs',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Breadcrumbs = withLogic(Component) as React.FC<BreadcrumbProps> & {
  slotName?: string;
};

Breadcrumbs.displayName = 'Breadcrumbs';
Breadcrumbs.slotName = 'jds_breadcrumbs';

export { Breadcrumbs, type JDSBreadcrumbsProps };
